import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {AbstractComponent} from "@components";
import {required} from '@utility';
import {Category, Gender} from "@model";
import {CategoryItemsValidationError} from "@pages";

@Component({
  selector: 'app-category-item-form',
  templateUrl: './category-item-form.component.html',
  styleUrls: ['./category-item-form.component.scss']
})
export class CategoryItemFormComponent extends AbstractComponent {

  @Input() inputForm: FormGroup<any> | undefined;
  @Input() itemsKey: string | undefined;
  @Input() gender: Gender | undefined;
  @Input() label: string = "";
  @Input() currentCategory: Category | undefined;
  @Output() deleteCategoryItems = new EventEmitter<any>();
  @Input() errors: CategoryItemsValidationError = new CategoryItemsValidationError();

  constructor(public formBuilder: FormBuilder) {
    super();
  }


  get items(): FormArray {
    return this.inputForm!.controls[this.itemsKey!] as FormArray;
  }

  deleteItems() {
    this.deleteCategoryItems.next(true);
  }


  getFormControl(index: number, name: string): FormControl | null {
    if (this.items.at(index)) {
      return this.items.at(index)!.get(name) as FormControl
    }
    return null;
  }

  getIndex(formGroup: FormGroup): number {
    return this.items.controls.indexOf(formGroup);
  }

  addItem() {
    let item = this.formBuilder.group({
      name: ['', required],
      code: ['', required],
      ageFrom: ['', required],
      ageTo: ['', required],
      gender: [this.gender, required],
      active: [false, required]
    });

    this.items.push(item);
  }

  deleteItem(index: number) {
    this.items.removeAt(index);
  }
}
